import { render, staticRenderFns } from "./FormBuilderOptionTab.vue?vue&type=template&id=7a4a76ef&"
import script from "./FormBuilderOptionTab.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderOptionTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports